import { initConnectNIM } from '../../libs/nim'
import { dealMessageItem, toast, getSession, globalModalLogic, storeConstLet, globalModalPay } from '../../libs/utils'
import { getNoticeList } from '../../api/user'
import { getCaramaSocketUrl, getAiCheckImageCenterId } from '../../config'
import { sortBy, find } from 'lodash'
import Bus from '../../libs/bus'
export default {
  state: {
    userId: '', //当前用户ID
    userName: '', //当前用户名
    currentCenterName: '',// 当前影像中心名称
    currentCenterId: '', //当前影像中心ID
    devices:[], //当前设备列表
    curDevice: '', // 当前设备ID
    nim: null, // NIM实例
    hasNewNotice: false, // 是否有新的通知
    waitingList: [], // 待领取当前页码数据
    caramaSocket: null, // 连接高拍仪的对象
    caramaConnectTime: 0, // 连接高拍仪次数
    caramaDialog: null, // 高拍仪句柄
    payType: '', // 各个营业点默认支付方式
    hospitalFlag: '' // 自营或合作
  },
  actions: {
    // 设置当前影像中心
    setCurrentCenter ({state}, center) {
      if (center.name) state.currentCenterName = center.name
      if (center.id) state.currentCenterId = center.id
      if (center.params) {
        try {
          let val = JSON.parse(center.params)
          state.payType = val && val.defaultPayChannel
        } catch (error) {
          console.log(error)
          throw new Error('解析JSON错误')
        }
      }
      if (center.selfRun.toString()) state.hospitalFlag = center.selfRun
      if (center.deviceVos) {
        state.devices = sortBy(center.deviceVos, 'id') || []
        state.curDevice = state.devices.length > 0 ? state.devices[0]['id'] : ''
      }
    },
    // 设置用户信息
    setUserInfo ({state}, user) {
      if (user.userName) state.userName = user.userName
      if (user.userId) state.userId = user.userId
    },
    // 设置当前所在设备
    setCurDevice ({state}, curDevice) {
      state.curDevice = curDevice
    },
    async connectNIM ({ state, dispatch }) {
      if (state.nim) return false
      const userInfo = getSession('risUserInfo', 'object')
      if (!userInfo || !userInfo.token_im) return toast({ msg: '获取用户IM账号异常' })
      let data = await initConnectNIM(userInfo, (msg) => {
        dispatch('dealMessage', msg)
      })
      if (data.nim) state.nim = data.nim
    },
    // 处理收到的信息
    async dealMessage ({state, dispatch}, message) {
      let msg = dealMessageItem(message)
      if (!msg || !msg.content || msg.content.system.toUpperCase()!== 'RIS') return false
      // AI支付提示弹窗
      if (state.currentCenterId == getAiCheckImageCenterId()) {
        if (!msg.content.sendUserId || msg.content.sendUserId != state.userId) return false
        return Bus.$emit('aiPayMessage', msg.content)
      }
      // 数据大屏
      if (msg.content && (msg.content.type === 'pay')) {
        return Bus.$emit('onlieRegistrationPay', msg.content)
      }
      if (!msg.content.receiveUserIdList || msg.content.receiveUserIdList.length < 1) return false
      let userInfo = getSession('risUserInfo', 'object') || null
      if (userInfo.id && msg.content.receiveUserIdList.includes(userInfo.id)) {
        let mesType = null
        try {
          let newCon = msg.content.content
          if (newCon.split('')[0] !== '{') mesType = msg.content
          else mesType = msg.content && msg.content.content && JSON.parse(msg.content.content)
        } catch (err) {
          throw (err)
        }
        if (msg.content.content && mesType.type === 'pay') {
          globalModalPay(msg.content)
        } else {
          globalModalLogic(msg.content) // 上传影像和解绑影像弹框
        }
        let statement = storeConstLet() // if判断所需变量库
        if (msg.content.msgType === statement.toast) { // 消息为普通消息
          toast({msg: msg.content.content || '', type: msg.content.level.toLowerCase(), title: '通知消息', duration: 5,  placement: 'bottomRight'})
        }
      }
      let list = await getNoticeList({pageNo: 1, pageSize: 10, readFlag: 0})
      if (list && list.totalCount > 0) dispatch('setHasNewNotice', true)
      else dispatch('setHasNewNotice', false)
    },
    // 设置是否有新的通知
    setHasNewNotice ({state}, val) {
      state.hasNewNotice = val
    },
    // 存待领取当前页码数据
    setWatingList ({state}, val) {
      state.waitingList = val
    },
    // 设置高拍仪的句柄
    initTakePhotoSocket ({state, dispatch}) {
      if (state.caramaSocket) return
      let isPad = navigator.userAgent.toLowerCase().match(/(ipod|ipad|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i) != null
      if (isPad) return false
      let userAuth = getSession('userAuth', 'object') || null
      if (!userAuth || !userAuth.authMenus || !find(userAuth.authMenus, (obj) => { return obj.title == '护士工作站' || obj.title == '技师工作站' })) return false
      if (state.caramaConnectTime >= 3) {
        toast({ msg: '高拍仪连接失败，请检查软件和设备是否正常' })
        return
      }
      let baseUrl = getCaramaSocketUrl()
      state.caramaSocket = new WebSocket(baseUrl)
      state.caramaSocket.onerror = (error) =>{
        state.caramaSocket = null
        console.log('websocket错误', error)
        return toast({ msg: 'websocket错误' })
      }
      state.caramaSocket.onclose = (ev) =>{
        state.caramaSocket = null
        if (parseInt(ev.code, 10) !== 1000) {
          setTimeout(() => {
            dispatch('initTakePhotoSocket', null)
            ++state.caramaConnectTime
          }, state.caramaConnectTime * 2000)
        }
      }
      state.caramaSocket.onopen = () =>{
        let QWebChannel = window.QWebChannel
        new QWebChannel(state.caramaSocket, (channel) => {
          state.caramaDialog = channel.objects.dialog
        })
      }
    },
    closePhotoDialog ({state}) {
      if (state.caramaDialog) {
        state.caramaDialog.get_actionType("closeSignal")
        state.caramaDialog = null
      }
      if (state.caramaSocket) {
        state.caramaSocket.close(1000, '正常关闭')
      }
    },
    // 重置数据
    resetAppStateData ({state}) {
      state.userId =  ''
      state.userName = ''
      state.currentCenterName = ''
      state.currentCenterId =  ''
      state.payType =  ''
      state.hospitalFlag = ''
      state.devices = []
      state.curDevice =  ''
      state.nim =  null
      state.hasNewNotice = false
      state.caramaSocket = null
      state.caramaDialog = null
      state.caramaConnectTime =  0
    }
  }
}